var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-divider',{style:({ '--divider-margin': (_vm.margin + "px 0px") })})}
var staticRenderFns = []

export { render, staticRenderFns }